import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cand-test-schedule',
  templateUrl: './cand-test-schedule.component.html',
  styleUrls: ['./cand-test-schedule.component.scss']
})
export class CandTestScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
